"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorClearHover = exports.colorClearNormal = exports.colorHover = exports.colorFocus = exports.colorNoFocus = void 0;
exports.colorNoFocus = 'rgba(0, 0, 0, 0.54)';
exports.colorFocus = '#303f9f';
exports.colorHover = '#000000';
exports.colorClearNormal = '#ff4040';
exports.colorClearHover = '#d00000';